import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TagDto } from '../entities/tag-dto';
import { TagApiService } from '../services/tag-api-service';

export const allTagsResolver: ResolveFn<TagDto[]> = () => {
  return inject(TagApiService).getAllTags();
};